module.exports = __webpack_public_path__ + "static/coffee-01d1e3294fbb0edb372ef1dde3567385.gif";